export default __webpack_public_path__ + "static/Equitrip-e218e97bffacfbe95526afb591e144a1.webp";